// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms & Conditions</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/glossary-faq">Glossary &amp; FAQ</Link>
        {/* <Link to="/landing-page">LandingPage</Link> */}

      </div>

      <div className="footer-copy">
        © {new Date().getFullYear()} StockVisualize
      </div>

      <div className="footer-disclaimer">
        IMPORTANT DISCLAIMER: All content provided herein our website, hyperlinked sites, associated applications,
        forums, blogs, social media accounts and other platforms (“Site”) is for your general information only,
        procured from third party sources. We make no warranties of any kind in relation to our content, including
        but not limited to accuracy and updatedness. No part of the content that we provide constitutes financial
        advice, legal advice or any other form of advice meant for your specific reliance for any purpose. Any use
        or reliance on our content is solely at your own risk and discretion. You should conduct your own research,
        review, analyse and verify our content before relying on them. Trading is a highly risky activity that can
        lead to major losses, please therefore consult your financial advisor before making any decision. No content
        on our Site is meant to be a solicitation or offer.
      </div>
    </footer>
  );
}
